module.exports = __webpack_public_path__ + "components/rewards/sixt/static/logo-11c38081d080cb259470631058ec770a.webp";